import React, { Component } from "react";
import { Button } from "reactstrap";

import { getMessage } from "CONFIG/i18n";
import { socketMessage } from "WEBSOCKET/constants";

import { ANNOTATIONS, LANGUAGE, FONT_SIZE, USER_ROLES } from "UTILS/Constants";
import { CANVAS_TYPES, FONT_FAMILY } from "UTILS/Constants";
import "./FloatedAnnotations.less";
import { func } from "prop-types";

import ic_text from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_text.svg";
import ic_text_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_text_selected.svg";
import ic_circle from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_circle.svg";
import ic_circle_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_circle_selected.svg";
import ic_freehand from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_freehand.svg";
import ic_freehand_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_freehand_selected.svg";
import ic_line from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_line.svg";
import ic_line_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_line_selected.svg";
import ic_rectangle from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_rectangle.svg";
import ic_rectangle_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_rectangle_selected.svg";
import ic_eraser from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_eraser.svg";
import ic_eraser_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_eraser_selected.svg";
import delete_object from "ASSETS/Images/ic_dustbin_unselected.svg";
import delete_object_disabled from "ASSETS/Images/FloatedAnnotations/ic_dustbin_disabled.svg";
import ic_rubber_disabled from "ASSETS/Images/FloatedAnnotations/ic_erazer_disabled.svg";

import increment from "ASSETS/Images/ic_font_size_plus.svg";
import decrement from "ASSETS/Images/ic_font_size_minus.svg";
import { isMobileView } from '@/Utils/Utility';

export default class FloatedAnnotationBar extends Component {
  constructor(props) {
    super(props);
  }
  static propTypes = {
    handleFloatedAnnotation: func
  };
  state = {
    activeAnnotation:this.props.selectedAnnotationByAgent && this.props.selectedAnnotationByAgent.annotation,
    shapes: {
      [ANNOTATIONS.TEXT]: {
        title: "TEXT_DECORATION",
        unselected: ic_text,
        selected: ic_text_selected,
        isSelected: false
      },
      [ANNOTATIONS.CIRCLE]: {
        title: "CIRCLE",
        unselected: ic_circle,
        selected: ic_circle_selected,
        isSelected: false
      },
      [ANNOTATIONS.RECTANGLE]: {
        title: "RECTANGLE",
        unselected: ic_rectangle,
        selected: ic_rectangle_selected,
        isSelected: false
      },
      [ANNOTATIONS.LINE]: {
        title: "LINE",
        unselected: ic_line,
        selected: ic_line_selected,
        isSelected: false
      },
      [ANNOTATIONS.FREE_HAND.NAME]: {
        title: "DRAW",
        unselected: ic_freehand,
        selected: ic_freehand_selected,
        isSelected: false
      },
      [ANNOTATIONS.ERASER.NAME]: {
        title: "ERASER",
        unselected: ic_eraser,
        selected: ic_eraser_selected,
        isSelected: false
      },
      [ANNOTATIONS.ERASE_OBJECT]: {
        title: "ERASE_OBJECT",
        unselected: delete_object,
        selected: delete_object,
        isSelected: false
      },
      [ANNOTATIONS.SELECTION]: {
        title: "SELECTION",
        unselected: null,
        selected: null,
        isSelected: false
      },
    }
  };
  updateState=()=>{
    const { annotation, isSelected } = this.props.selectedAnnotationByAgent;
    if(annotation){
      let shapes=this.state.shapes;
      Object.keys(this.state.shapes).map(shape=>{
        if (shape === annotation) {
          shapes[shape].isSelected =  isSelected;
        } else {
          shapes[shape].isSelected = false;
        }
      })
      this.setState({
        shapes,
        activeAnnotation:annotation
      })
    }
  }
  componentDidMount() {
    if(this.props.selectedAnnotationByAgent.annotation === this.props.selectedAnnotation){
      this.updateState();
    }
  }
  
  componentDidUpdate(prevProps,prevState) {
    const {annotation}=this.props.selectedAnnotationByAgent;
    if(prevProps.selectedAnnotationByAgent.annotation!==annotation){
      this.updateState();
    }
    if(prevProps.disableClearCanvas !== this.props.disableClearCanvas &&
      this.props.disableClearCanvas &&
      this.props.organiser === this.props.uniqueId &&
      (this.props.selectedAnnotation === ANNOTATIONS.ERASER.NAME ||
        this.props.selectedAnnotation === ANNOTATIONS.ERASE_OBJECT)) {
      this.handleChangeAnnotation(this.props.selectedAnnotation);
    }
  }

  handleChangeAnnotation = (annotation, isEraserClick) => {
    let shapes = this.state.shapes;
    shapes[annotation] = this.state.shapes[annotation];
    Object.keys(this.state.shapes).map(shape=>{
      if(shape===annotation){
        // FIXME:Uncomment to avoid default selection of eraser when delete object is selected
        shapes[shape].isSelected = isEraserClick ? true : !this.state.shapes[annotation].isSelected
        //shapes[shape].isSelected = !this.state.shapes[annotation].isSelected
      }else{
        shapes[shape].isSelected=false;
      }
    })
    this.setState({
      shapes: shapes,
      activeAnnotation:annotation
    });

    // FIXME:Uncomment to avoid default selection of eraser when delete object is selected
    // if(annotation != ANNOTATIONS.ERASER.NAME || 
    //   (annotation == ANNOTATIONS.ERASER.NAME && this.props.selectedAnnotation != ANNOTATIONS.ERASE_OBJECT) ||
    //   isEraserClick)
    this.handleFloatedAnnotationWSMessage(annotation,shapes);
  };

  handleFloatedAnnotationWSMessage=(annotation,shapes)=>{
    const {
      ADD_ANNOTATION,
      REMOVE_ANNOTATION
    } = socketMessage.subCategories.NOTIFICATION;
    const message = {
      data: {
        category: socketMessage.category.NOTIFICATION,
        action: shapes[annotation].isSelected
          ? ADD_ANNOTATION
          : REMOVE_ANNOTATION,
        annotation: annotation
      }
    };
    this.props.handleFloatedAnnotation(socketMessage.events.MESSAGE, message);
  }
  
  handleChangeFontSize = event => {
    this.props.handleChangeFontSize(event.target.value);
  };
  eraseOnCanvas = () => {
    this.props.eraseOnCanvas();
  };
  clearCanvas = () => {
    this.props.clearCanvas();
  };

  renderFontSizeOptions = () => {
    return FONT_SIZE.map(fontSize => {
      return <option value={fontSize}>{fontSize}</option>
    })
  }

  incrementFont = () => {
    let index = FONT_SIZE.indexOf(this.props.selectedFontSize)
    this.props.handleChangeFontSize(FONT_SIZE[index===(FONT_SIZE.length - 1) ? index : index+1]);
  }

  decrementFont = () => {
    let index = FONT_SIZE.indexOf(this.props.selectedFontSize)
    this.props.handleChangeFontSize(FONT_SIZE[index<=0 ? 0 : index-1]);
  }

  renderAnnotations = () => {
    return Object.keys(this.state.shapes).filter(shapes => {
      return this.props.organiser === this.props.uniqueId
        ? shapes !== ANNOTATIONS.ERASE_OBJECT && shapes !== ANNOTATIONS.SELECTION
        : null }).map(shape => {

      let shapeObject = this.state.shapes[shape];
      const { title, selected, unselected, isSelected } = shapeObject;
      const iconSelected = (isSelected || title === "ERASER" && this.state.activeAnnotation === ANNOTATIONS.ERASE_OBJECT);
      return (
        <div 
          key={shape + title}
          className={`floatingAnnotation ${iconSelected && "iconSelected"} ${this.props.organiser !== this.props.uniqueId && "guestAnnotation"}`} 
        >
          <img
            src={title == "ERASER" && this.props.disableClearCanvas
              ? ic_eraser
              : isSelected
                ? selected
                : title == "ERASER" && this.state.shapes[ANNOTATIONS.ERASE_OBJECT].isSelected
                  ? selected
                  : unselected
            }
            alt={title}
            className={title == "ERASER" && this.props.disableClearCanvas 
              ? "isDisabled disablederaser"
              : "blinkImg cursorPointer"}
            title={getMessage(title)}
            onClick={() => {
              this.handleChangeAnnotation(shape);
            }}
          />
          {isSelected && this.state.activeAnnotation === ANNOTATIONS.TEXT&&
          <span id="divIdToggle" className=" cursorPStyle">
            {(this.props.canvasType !== CANVAS_TYPES.PDF ||
              this.props.isPresenter ||
              this.props.organiser === this.props.uniqueId ||
              !this.props.isInkLocked) && (
              <React.Fragment>
                <span id="DIVErase">
                  {this.props.language !== LANGUAGE.JA.name?
                    <React.Fragment>
                      <span className="invitee mr-2">
                        <select type="select" className="inputFormControl selectText width5em cursorPointer"
                          onChange={this.props.handleChangeFontFamily}
                          value={this.props.selectedFontFamily}
                          onClick={() => {
                            this.props.handleChangeAnnotation(ANNOTATIONS.TEXT);
                          }}
                        >
                          {Object.keys(FONT_FAMILY).map(fontFamily => {
                            return <option key={fontFamily} value={FONT_FAMILY[fontFamily]}>{getMessage(fontFamily)}</option>
                          })}
                        </select>
                      </span>
                      {/* <hr className=" displayInline" /> */}
                    </React.Fragment>
                    : null
                  }
                  <img 
                    className="fontSizeIcon cursorPointer"
                    src={decrement}
                    onClick={this.decrementFont}
                  />
                  <select type="select" className="inputFormControl selectText cursorPointer"
                    onChange={this.handleChangeFontSize}
                    value={this.props.selectedFontSize}
                  >
                    {this.renderFontSizeOptions()}
                  </select>
                  <img 
                    className="fontSizeIcon cursorPointer"
                    src={increment}
                    onClick={this.incrementFont}
                  />
                  {/*this.props.organiser === this.props.uniqueId && (
                    <Button
                      className="textSetDefault whiteOnClick cursorPointer ml-2"
                      onClick={()=>{this.props.setDefaultFontInfo(null,false)}}
                    >
                      {getMessage("SET_AS_DEFAULT")}
                    </Button>
                  )*/}
                </span>
              </React.Fragment>
            )}
          </span>}
          {iconSelected && this.props.organiser === this.props.uniqueId &&
          (this.state.activeAnnotation === "Eraser" ||
          this.state.activeAnnotation === "Erase Object") &&
            <span id="divIdToggle2" className=" cursorPStyle">
              <img
                src={
                  this.props.disableClearCanvas
                    ? ic_rubber_disabled
                    : ic_eraser
                }
                alt="eraser"
                title={getMessage("ERASER")}
                className={this.props.disableClearCanvas
                  ? "img-fluid isDisabled cursorPointer mr-2"
                  : "img-fluid cursorPointer mr-2"}
                onClick={() => {
                  this.handleChangeAnnotation(ANNOTATIONS.ERASER.NAME, true);
                  this.eraseOnCanvas();
                }}
              />
              <img
                src={
                  this.props.disableClearCanvas
                    ? delete_object_disabled
                    : delete_object
                }
                title={getMessage("DELETE_OBJECT")}
                alt="eraser"
                className={this.props.disableClearCanvas
                  ? "img-fluid isDisabled cursorPointer mr-2"
                  : "img-fluid cursorPointer mr-2"
                }
                onClick={() =>
                  this.handleChangeAnnotation(ANNOTATIONS.ERASE_OBJECT, true)
                }
              />
              {this.props.userRole !== USER_ROLES.USER && <Button
                className={this.props.disableClearCanvas
                  ? "textSetDefault isDisabled whiteOnClick"
                  : "textSetDefault cursorPointer whiteOnClick"}
                onClick={this.clearCanvas}
              >
                {getMessage("RESET_DRAWING")}
              </Button>}
            </span>
          }
        </div>
      );
    });
  };
  render() {
    const wrapAnnotations = (this.state.shapes[ANNOTATIONS.TEXT].isSelected || this.state.shapes[ANNOTATIONS.ERASER.NAME].isSelected || this.state.shapes[ANNOTATIONS.ERASE_OBJECT].isSelected);
    const isWrap = isMobileView(this.props.orientation) && wrapAnnotations && this.props.organiser === this.props.uniqueId;

    return <div className={isWrap ? "floatedAnnotations annotationRow" : "floatedAnnotations"} >{this.renderAnnotations()}</div>;
  }
}
